// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__3QuDF","text":"text__1i154","button-wrapper":"button-wrapper__2f8eV"};